import { createFeatureSelector } from '@ngrx/store';
import { rootApplicationKeyState } from './root.reducer';

export const rootState = createFeatureSelector(rootApplicationKeyState);
